import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SelectionState {
  selectedItems: {
    [pageKey: string]: any[];
  };
}

const initialState: SelectionState = {
  selectedItems: {},
};

const selectionSlice = createSlice({
  name: "selection",
  initialState,
  reducers: {
    setSelectedItems: (
      state,
      action: PayloadAction<{ pageKey: string; items: any[] }>
    ) => {
      state.selectedItems[action.payload.pageKey] =
        action.payload.items;
    },

    clearSelectedItems: (state, action: PayloadAction<string>) => {
      state.selectedItems[action.payload] = [];
    },

    clearAllSelectedItems: (state) => {
      state.selectedItems = {};
    },
  },

});

export const { setSelectedItems, clearSelectedItems, clearAllSelectedItems } = selectionSlice.actions;
export default selectionSlice.reducer;
